import api from '@/libs/axios'

export default {
  async getCategoryList(params) {
    let response = await api.get('/admin/pronun-categories', {
      params,
    })
    return response.data.type === 'DATA' ? response.data.data.list : []
  },
  async updateCategory(payload) {
    let response = await api.put('/admin/pronun-categories', payload)
    return response
  },
  async create(payload) {
    const response = await api.post('/admin/pronun-lessons', payload)
    return response.data.data.new_document || null
  },
  async getList(params) {
    let response = await api.get('/admin/pronun-lessons', {
      params,
    })
    return response.data.data || null
  },
  async get(params) {
    let response = await api.get('/admin/pronun-lessons/detail', {
      params,
    })
    return response.data.data.document || null
  },
  async update(payload) {
    let response = await api.put('/admin/pronun-lessons', payload)
    return response
  },
  async delete(payload) {
    const response = await api.delete('/admin/pronun-lessons', {
      data: payload,
    })
    return response
  },
  async getAll() {
    const response = await api.get('/admin/pronun-lessons/all')
    return response.data.data || null
  }

}
